const siteConfig = {
  siteName: 'Victorian Cruise Society',
  siteUrl: 'https://victoriancruisesociety.org',
  contactEmail: 'admin@victoriancruisesociety.org',
  legalUrl: 'https://victoriancruisesociety.org/legal',
  social: {
    instagram: 'https://www.instagram.com/victoriancruisesociety/',
    facebook: 'https://www.facebook.com/profile.php?id=61569641520489',
    twitterHandle: '@victoriancruisesociety',
  },
};

export default siteConfig;
